<template>
    <a-modal v-model="visible" :title="'离职操作'" @ok="handleOk" :confirm-loading="confirmLoading" @cancel="handleCancel"
        :maskClosable="false" :keyboard="false">
        <a-row :gutter="20">
            <a-col :span="24">
                <a-form-model ref="ruleForm" :model="form" :rules="rules">
                    <a-alert message="建议将离职员工的客户转移到【张彬】账号下" type="info" show-icon style="margin-bottom: 10px;" />
                    <a-alert message="一旦设置离职后，转移的会员信息将不可撤回，请谨慎操作！" type="info" show-icon style="margin-bottom: 10px;" />
                    <a-alert message="转移的数据包括：" description='1. 将转移所有正在跟进的会员
            2. 客户档案中->基本信息->运营人员
            3. 已关联的行程：销售人员、计调人员、运营人员
            4. 会员入会操作人' type="info" show-icon />
                    <a-form-model-item
                        v-if="form.movetype1 == 1 || form.movetype2 == 1 || form.movetype3 == 1 || form.movetype3 == 1"
                        :label="form.real_name + '的数据转移到哪个账号？'" prop="move_id">
                        <a-select v-model="form.move_id" placeholder="请选择" option-label-prop="label"
                            :filter-option="$filterOption" showSearch allowClear>
                            <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id"
                                :label="v.real_name">
                                {{ v.real_name }}
                                <span role="img" :aria-label="v.real_name" style="font-size: 14px; color: #888">
                                    ({{ v.department.department_name }})
                                </span>
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item label="转移：所有会员" prop="movetype1">
                        <a-radio-group v-model="form.movetype1">
                            <a-radio value="1">转移</a-radio>
                            <a-radio value="2">不转移</a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="转移：基本信息->运营人员" prop="movetype2">
                        <a-radio-group v-model="form.movetype2">
                            <a-radio value="1">转移</a-radio>
                            <a-radio value="2">不转移</a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="转移：关联行程的销售、计调、运营人员" prop="movetype3">
                        <a-radio-group v-model="form.movetype3">
                            <a-radio value="1">转移</a-radio>
                            <a-radio value="2">不转移</a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item label="转移：会员入会操作人" prop="movetype4">
                        <a-radio-group v-model="form.movetype4">
                            <a-radio value="1">转移</a-radio>
                            <a-radio value="2">不转移</a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                </a-form-model>
            </a-col>
            <!-- <a-col :span="12">
                
            </a-col> -->
        </a-row>
    </a-modal>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            confirmLoading: false,
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            userList: [],
            form: {
                real_name: '',
                user_id: undefined,
                move_id: undefined,
                movetype1: "1",
                movetype2: "1",
                movetype3: "1",
                movetype4: "1",
            },
            rules: {
                move_id: [
                    {
                        required: true,
                        message: "请选择转移后的目标用户",
                        trigger: "blur",
                    },
                ],
            }
        }
    },
    methods: {
        init({ user_id, real_name }) {
            this.visible = true;
            this.form.user_id = user_id;
            this.form.real_name = real_name;
            this.getUserList()
        },
        getUserList() {
            this.$http({
                url: "/admin/user/page?page=1&limit=200",
                method: "get",
            }).then((res) => {
                this.userList = res.data.result;
            });
        },
        handleOk() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.confirmLoading = true;
                    this.$http({
                        url: '/admin/user/lizhi',
                        method: "post",
                        data: {
                            ...this.form,
                        },
                    })
                        .then(() => {
                            this.$message.success('操作成功');
                            this.handleCancel();
                            this.$emit("ok");
                        })
                        .finally(() => {
                            this.confirmLoading = false;
                        });
                }
            })
        },
        handleCancel() {
            this.visible = false;
            this.$refs["ruleForm"].resetFields();
            this.confirmLoading = false;
        },
    }
}
</script>